export default __webpack_public_path__ + "static/media/wordSearch.ed129f1f.jpg";